export { DependentLayout } from './Layout';
